module.exports = __webpack_public_path__ + "img/news4.10cb98a0.png";